import { errorReplacer } from ':helpers/error-replacer';

export function stringifySafe(obj: unknown): string {
    try {
        return JSON.stringify(obj, errorReplacer);
    } catch {
        return '[stringifySafe] Cant stringify obj';
    }
}
